import React from 'react';
import { User } from '../utils/auth';
import BtcIcon from './icons/BtcIcon';

interface HeaderProps {
  currentUser: User | null;
  onLoginClick: () => void;
  onLogout: () => void;
}

const Header: React.FC<HeaderProps> = ({ currentUser, onLoginClick, onLogout }) => {
  return (
    <header className="bg-navy-blue/50 backdrop-blur-sm shadow-lg sticky top-0 z-50">
      <div className="container mx-auto px-4 py-4 flex justify-between items-center">
        <div className="flex items-center">
          <BtcIcon className="w-8 h-8 mr-3" />
          <h1 className="text-2xl font-bold text-off-white tracking-tight">BTC Gain & Loss</h1>
        </div>
        <div className="flex items-center space-x-4">
          {currentUser && (
            <span className="text-light-blue">Welcome, <span className="font-bold text-off-white">{currentUser.username}</span>!</span>
          )}
          <button
            onClick={currentUser ? onLogout : onLoginClick}
            className="bg-btc-orange text-dark-blue font-bold py-2 px-4 rounded-lg hover:bg-orange-400 transition-colors duration-300"
          >
            {currentUser ? 'Sign Out' : 'Sign In'}
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header;